<template>
	<span @click="$emit('acao')">
		<icone-simples-redondo-com-label
			label-botao="E"
			texto="Estorno completo"
			cor-background="orange"
		></icone-simples-redondo-com-label>
	</span>
</template>
<script>
import IconeSimplesRedondoComLabel from '@/views/components/icones/IconeSimplesRedondoComLabel.vue'

export default {
	name: 'icone-estornado',
	components: { IconeSimplesRedondoComLabel },
}
</script>
